const config = {
    SITE_NAME: 'shipsy-test',
     SENTRY_AUTH_TOKEN: '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',
    CHARGEBEE_PUBLISHABLE_KEY: 'pk_test_51JKjDrSAKsnOBoNKQxuagv3djtBc1K4fFVNUIuCIHokB6MxtHQ7avdLY88bFV4xeEvDEI1snNt8xB5RO14SPXP2W00k7OWoRYx',
    SOCKET_SERVER_URL: 'https://api.shipsy.in:4201/shipper-dashboard',
    API_BASE_URL: 'https://shipperdashboarddemoapi.shipsy.in',
    GENERIC_ANALYTICS_URL: 'https://shipsyexim.analyticsdashboarddemo.shipsy.io',
    GOOGLE_ANALYTICS_MEASUREMENT_ID: 'UA-86979717-10',
    LOG_ROCKET_KEY: 'ni1awe/shippers-demo-wlcrb',
    CT_POLLING_FREQUENCY: 10000,
    SENTRY_KEY: 'https://f07dff4013ab437b9fc5e6079b324332@sentry.io/1445586',
    ENVIRONMENT: 'demo',
    LTL_POLLING_FREQUENCY:5000,
    DOMESTIC_STATUS_FETCH_POLLING_FREQUENCY:5000,
    SIDEMENU_CONFIG: {
    show_play: true,
    show_exception_rules: true,
    show_exception_alerts: true,
    show_imports: true,
    show_exports: true,
    show_container_tracking: true,
    show_container_tracking_exports: true,
    show_container_tracking_imports: true,
    show_shipping_management: true,
    show_user_management: true,
    show_account: true,
    show_rfq: true,
    show_bidding: true,
    show_new_exports : true,
    show_rake_exports: true,
    show_exports_sales_order: true,
    show_new_imports : true,
    show_rake_imports: true,
    show_imports_sales_order: true
    },
    RFQ_ANALYTICS_DATA: [
    {
      src: 'https://datastudio.google.com/embed/reporting/1_Lq6f1qKawiCZOlrpODegTDpKNy0JJSD/page/rT6l',
      colSpan: 24,
      height: '700px',
    },
    {
      src: 'https://datastudio.google.com/embed/reporting/1kc080SOD5s_u3py6eH45UEgnaH6Q0Ze7/page/rT6l',
      colSpan: 24,
      height: '650px',
    },
    {
      src: 'https://datastudio.google.com/embed/reporting/1AH5Q0QPWz7_ET5s57e8bukHFMd4Uywoa/page/rT6l',
      colSpan: 24,
      height: '500px',
    },
  ],
}
module.exports.default = config;
